import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";
import { useFetch } from "@/lib/hooks";
import { fmtDate, km } from "@/lib/format";
import { Empty, Loading, PageHeader, Panel, StatusBadge, Table, cellCls, rowCls } from "@/components/common";
import { Button } from "@/components/ui/button";

const FILTERS = [["presente", "À l'atelier"], ["restitue", "Restitués"], ["", "Tous"]];

export default function Receptions() {
  const [status, setStatus] = useState("presente");
  const nav = useNavigate();
  const { data, loading } = useFetch<any[]>(`/receptions?status=${status}`);
  return (
    <div>
      <PageHeader eyebrow="Entrées atelier" title="Réceptions"
        actions={<Link to="/receptions/nouvelle"><Button className="h-11" data-testid="new-reception-btn"><Plus className="mr-2 h-4 w-4" />Nouvelle réception</Button></Link>} />
      <div className="mb-4 flex gap-2">
        {FILTERS.map(([v, l]) => (
          <button key={v} onClick={() => setStatus(v)} className={`h-9 rounded-sm border px-4 text-sm transition-colors ${status === v ? "border-primary bg-primary/10" : "border-border hover:bg-accent"}`} data-testid={`receptions-filter-${v || "all"}`}>{l}</button>
        ))}
      </div>
      <Panel>
        {loading ? <Loading /> : !data?.length ? <Empty text="Aucune réception" /> : (
          <Table head={["N°", "Véhicule", "Client", "Kilométrage", "Demande", "Entrée", "Statut"]} testId="receptions-table">
            {data.map((r) => (
              <tr key={r.id} className={rowCls} onClick={() => nav(`/receptions/${r.id}`)} data-testid={`reception-row-${r.id}`}>
                <td className={`${cellCls} font-mono-data font-semibold`}>{r.number}</td>
                <td className={cellCls}><span className="font-mono-data">{r.plate}</span> <span className="text-xs text-muted-foreground">{r.vehicle_label}</span></td>
                <td className={cellCls}>{r.client_name}</td>
                <td className={`${cellCls} font-mono-data`}>{km(r.mileage)}</td>
                <td className={`${cellCls} max-w-[260px] truncate text-muted-foreground`}>{r.customer_request}</td>
                <td className={`${cellCls} text-muted-foreground`}>{fmtDate(r.created_at)}</td>
                <td className={cellCls}><StatusBadge status={r.status} /></td>
              </tr>
            ))}
          </Table>
        )}
      </Panel>
    </div>
  );
}
